export const API = "https://newbackend.infoethiopia.net/api";


